module.exports = __webpack_public_path__ + "img/fanta.b1ffd66b.png";